import React, { useEffect } from 'react';

export default function Login({ onLogin }) {
  const portalUrl = process.env.REACT_APP_PORTAL_URL || 'https://portal.zlinkint.com';

  useEffect(() => {
    // Si hay ?session_error en la URL, mostrar mensaje
  }, []);

  return (
    <div style={{
      display:'flex', flexDirection:'column', alignItems:'center',
      justifyContent:'center', height:'100vh',
      background:'linear-gradient(135deg, #04080f 0%, #0b132b 100%)'
    }}>
      <div style={{
        background:'#0b132b', border:'1px solid #1c2541',
        borderRadius:12, padding:48, width:380, textAlign:'center'
      }}>
        <img src="/logo.png" alt="ZLinkINT" style={{ height:56, width:56, objectFit:'cover', borderRadius:10, display:'block', margin:'0 auto 16px' }} />
        <h1 style={{ color:'#00c8ff', fontSize:22, fontWeight:700, marginBottom:4 }}>
          GPS TRACKING
        </h1>
        <p style={{ color:'#8892a4', fontSize:13, marginBottom:32 }}>
          Módulo de seguimiento geoespacial · ZlinkINT
        </p>

        <div style={{
          background:'#04080f', border:'1px solid #1c2541',
          borderRadius:8, padding:16, marginBottom:24, textAlign:'left'
        }}>
          <p style={{ color:'#8892a4', fontSize:12, lineHeight:1.6 }}>
            El acceso a este módulo se realiza a través del{' '}
            <strong style={{ color:'#e0e1dd' }}>Portal ZlinkINT</strong>.
            Inicia sesión en el portal y selecciona el módulo GPS.
          </p>
        </div>

        <a href={portalUrl} style={{
          display:'block', background:'#ff6600', color:'#fff',
          padding:'12px 24px', borderRadius:8, fontWeight:700,
          fontSize:14, textDecoration:'none', letterSpacing:.5
        }}>
          Ir al Portal ZlinkINT →
        </a>

        <p style={{ color:'#1c2541', fontSize:11, marginTop:24 }}>
          GPS Tracking v1.0 · Clasificación RESERVADO
        </p>
      </div>
    </div>
  );
}
